import { Chip, inputBaseClasses } from '@mui/material';
import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';
import React from 'react';

export const MuiAutocomplete: Components<Omit<Theme, 'components'>>['MuiAutocomplete'] = {
  styleOverrides: {
    inputRoot: ({ theme }) => (
      {
        '&:not(.Mui-focused)': {
          flexWrap: 'nowrap !important',
        },
        '&.Mui-focused.MuiFilledInput-input': {
          position: 'absolute',
          top: '25px',
          zIndex: 1,
          backgroundColor: theme.palette.background.default,
        },
        [`& .${inputBaseClasses.input}.MuiFilledInput-input`]: {
          padding: '12px',
        },
      }
    ),
  },
  defaultProps: {
    getLimitTagsText: (more) => (
      <Chip
        label={`+${more}`}
        size="small"
      />
    ),
  },
};
